import { AxiosInstance } from 'axios';
import { ApiResult } from 'services/api/result.type';
import { CoCurricularApi } from './co-curricular.api';
import { GetLearningOutcomeHoursResponse } from './dto/learning-outcome-hours.dto';
import { GetNaceCompetencyHoursResponse } from './dto/nace-competency-hours.dto';
import { GetEntriesResponse } from './dto/entries.dto';
import { GetLeadershipPositionsResponse } from './dto/leadership-positions.dto';
import { GetSummaryResponse } from './dto/summary.dto';

// Admin-scoped variant of CoCurricularApi. Every call is bound to a target
// student (userId) and hits the executive-admin endpoints. Provide an
// instance of this through CoCurricularApiProvider so the existing
// profile/ transcript components render a student's record for an admin.
export class AdminCoCurricularApi extends CoCurricularApi {
  public constructor (
    api: AxiosInstance,
    private readonly userId: string,
  ) {
    super(api);
  }

  public async getLearningOutcomeHours (): ApiResult<GetLearningOutcomeHoursResponse> {
    return await this.get<GetLearningOutcomeHoursResponse>(
      `/co-curricular/admin/${this.userId}/learning-outcome-hours`,
    );
  }

  public async getNaceCompetencyHours (): ApiResult<GetNaceCompetencyHoursResponse> {
    return await this.get<GetNaceCompetencyHoursResponse>(
      `/co-curricular/admin/${this.userId}/nace-competency-hours`,
    );
  }

  public async getEntries (page: number): ApiResult<GetEntriesResponse> {
    return await this.get<GetEntriesResponse>(
      `/co-curricular/admin/${this.userId}/entries`,
      { params: { page } },
    );
  }

  public async getLeadershipPositions (): ApiResult<GetLeadershipPositionsResponse> {
    return await this.get<GetLeadershipPositionsResponse>(
      `/co-curricular/admin/${this.userId}/leadership-positions`,
    );
  }

  public async getSummary (): ApiResult<GetSummaryResponse> {
    return await this.get<GetSummaryResponse>(
      `/co-curricular/admin/${this.userId}/summary`,
    );
  }
}
